<script>
const weekDays = {
  mon: [],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: []
}
const weekdayNames = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export default {
  name: 'Schedule',
  props: {
    value: { type: Object, required: true }
  },
  data() {
    // Prefill form
    return {
      pickedDates: weekDays,
      scheduleDates: [
        { title: 'Monday', value: 'mon' },
        { title: 'Tuesday', value: 'tue' },
        { title: 'Wednesday', value: 'wed' },
        { title: 'Thursday', value: 'thu' },
        { title: 'Friday', value: 'fri' },
        { title: 'Saturday', value: 'sat' },
        { title: 'Sunday', value: 'sun' }
      ],
      lunch: false,
      dinner: false
    }
  },
  computed: {
    // Get Allowed Times for Each Date
    allowedHours() {
      const times = []
      for (let i = 10; i < 22; i++) {
        times.push({ label: `${i}:00`, value: i })
      }
      return times
    }
  },
  created() {
    const { pick, merge, includes } = this.lodash
    const pickedDates = pick(this.value, weekdayNames)

    this.pickedDates = merge(this.pickedDates, pickedDates)

    const { wed } = this.pickedDates
    if (includes(wed, 11) && includes(wed, 12)) {
      this.lunch = true
    }
    if (includes(wed, 18) && includes(wed, 19)) {
      this.dinner = true
    }
  },
  methods: {
    onLunchChange() {
      const { union, without } = this.lodash
      const { wed } = this.pickedDates

      this.$emit('input', {
        ...this.pickedDates,
        wed: this.lunch ? union(wed, [11, 12]) : without(wed, 11, 12)
      })
    },
    onDinnerChange() {
      const { union, without } = this.lodash
      const { wed } = this.pickedDates

      this.$emit('input', {
        ...this.pickedDates,
        wed: this.dinner ? union(wed, [18, 19]) : without(wed, 18, 19)
      })
    }
  }
}
</script>

<template>
  <!-- Schedule -->
  <div class="schedule">
    <!-- Schedule Example -->
    <div class="my-5">
      <div class="font-weight-bold">
        Example
      </div>
      <div class="body-2 mt-1">
        If you pick Wednesday 11am, Pona users will be able to order your food
        until Tuesday 11am. You'll get a notification of each order, and must
        have the food ready for pickup by Wednesday 10:45am.
      </div>
    </div>

    <!-- Scheduling Dates -->
    <!-- <div v-for="date in scheduleDates" :key="date.title">
      <div class="font-weight-bold body-1 mb-4">
        {{ date.title }}
      </div>
      <v-layout wrap>
        <v-flex v-for="(time, i) in allowedHours" :key="i" xs3>
          <v-checkbox
            v-model="pickedDates[date.value]"
            :value="time.value"
            color="primary"
            class="pa-0 ma-0"
            @change="onChange"
          >
            <template v-slot:label>
              <div class="body-2 black--text">
                {{ time.label }}
              </div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </div> -->

    <div>
      <div class="font-weight-bold body-1 mb-4">
        Wednesday
      </div>
      <v-layout wrap>
        <v-flex>
          <v-checkbox
            v-model="lunch"
            color="primary"
            class="pa-0 ma-0"
            @change="onLunchChange"
          >
            <template v-slot:label>
              <div class="body-2 black--text">
                Lunch (11am–1pm)
              </div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex>
          <v-checkbox
            v-model="dinner"
            color="primary"
            class="pa-0 ma-0"
            @change="onDinnerChange"
          >
            <template v-slot:label>
              <div class="body-2 black--text">
                Dinner (6–8pm)
              </div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<style lang="sass">
.onboarding-profile-schedule
  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot
    margin: 0
</style>
